import { render, staticRenderFns } from "./AboutContactWithChildOrder.vue?vue&type=template&id=7ba89f49"
import script from "./AboutContactWithChildOrder.vue?vue&type=script&lang=ts"
export * from "./AboutContactWithChildOrder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports